export default ['TN','CA','OK','SC','AL', 'FL', 'TX']
export const EARLY24_BLOCKED_STATES = [
    'GA', 'FL', 'IN', 'OH', 'MI', 'AZ', 'HI', 'AL', 'CA','TN','SC','NC','WV','TX', 'OK', 'SD', 'OR', 'NV'
];
export const STORE_ALLOWED_DISCOUNT_CODES = [
    'BUNDLE2', 'BUNDLE3','EARLY24','HW20', 'NYPROMO', 'ARK26', 'MO2026', 'EDWEEKBUNDLE'
];